"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoggerWithDefaults = createLoggerWithDefaults;
const createLogger_1 = __importDefault(require("../common/createLogger"));
const constants_1 = require("../common/constants");
/* c8 ignore start */
exports.default = (0, createLogger_1.default)(Object.assign({}, constants_1.DEFAULT_OPTIONS));
/**
 * Creates a logger with default TELUS options. You are free to override
 * anything in here.
 */
function createLoggerWithDefaults(options = {}) {
    return (0, createLogger_1.default)(Object.assign(Object.assign({}, constants_1.DEFAULT_OPTIONS), options));
}
/* c8 ignore stop */
